import React from "react";
import { Radio } from "@material-ui/core";
import { FormControlLabel, RadioGroup } from "../../components/Steps";
import type { IStep } from "./index";
import type { IAnswers } from "../../steps";

export interface YesNoProps {
  step: IStep;
  onChange: (answer: IAnswers) => void;
  value?: string;
}

function YesNo({ step, onChange, value }: YesNoProps) {
  const change = (answer: IAnswers) => () => {
    onChange(answer);
  };

  return (
    <RadioGroup value={value} name={step.step}>
      {step.answers.map((a, index) => {
        const debugFeatures = step.ansewers[index]?.features;
        return (
          <React.Fragment key={a.name}>
            <FormControlLabel
              onChange={change(a)}
              value={a.name}
              control={<Radio />}
              label={a.content}
            />
            {process.env.REACT_APP_DEBUG && debugFeatures && (
              <div style={{ marginTop: "-20px", marginBottom: "20px" }}>
                {debugFeatures.map((f: any) => (
                  <p key={f.nameVerbose}>
                    {f.nameVerbose} {f.valueVerbose}
                  </p>
                ))}
              </div>
            )}
          </React.Fragment>
        );
      })}
    </RadioGroup>
  );
}

export default YesNo;
